import React from 'react';
import WomensGoalSection, { WOMENS_FIELD_LINE, WOMENS_FIELD_W } from '../../../components/shared/WomensGoalSection';

const LINE = WOMENS_FIELD_LINE;
const FIELD_W = WOMENS_FIELD_W;

/** Center circle on the line drawing: diameter 190, short dash 32, restraining lines 40 away. */
const CENTER_R = 95;
const CENTER_DASH = 16;
const CENTER_GAP = 40;
const CENTER_BOX = (CENTER_R + CENTER_GAP) * 2;

/**
 * Center circle with the same short dash as the goal circle.
 * The lines above and below sit clear of the circle, the way the restraining
 * lines sit on the women's field.
 */
const CenterCircle: React.FC = () => (
  <div className="absolute left-0 right-0 top-1/2 w-full -translate-y-1/2">
    <div className="relative w-full" style={{ paddingTop: `${(CENTER_BOX / FIELD_W) * 100}%` }}>
      <div className="absolute -left-[12%] -right-[12%] top-0 h-px" style={{ backgroundColor: LINE }} />
      <div className="absolute -left-[12%] -right-[12%] bottom-0 h-px" style={{ backgroundColor: LINE }} />
      <svg
        viewBox={`0 0 ${CENTER_R * 2} ${CENTER_R * 2}`}
        preserveAspectRatio="xMidYMid meet"
        className="absolute left-1/2 top-1/2 w-[33.1%] -translate-x-1/2 -translate-y-1/2 overflow-visible"
        aria-hidden
      >
        <g fill="none" stroke={LINE} strokeWidth="2.25" strokeLinecap="round">
          <circle cx={CENTER_R} cy={CENTER_R} r={CENTER_R} />
          <line x1={CENTER_R - CENTER_DASH} y1={CENTER_R} x2={CENTER_R + CENTER_DASH} y2={CENTER_R} />
        </g>
      </svg>
    </div>
  </div>
);

/**
 * Side edges stay off the capture screen. Top and bottom lines run the full
 * playground width. Goal sections scale to that width. The center circle sits
 * in the middle of the buttons, with lines held off the circle.
 */
const CapturePlayground: React.FC<{ className?: string }> = ({ className = '' }) => (
  <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden>
    <div className="absolute -left-[12%] -right-[12%] top-0 h-px" style={{ backgroundColor: LINE }} />
    <WomensGoalSection edge="top" />
    <CenterCircle />
    <WomensGoalSection edge="bottom" />
    <div className="absolute -left-[12%] -right-[12%] bottom-0 h-px" style={{ backgroundColor: LINE }} />
  </div>
);

export default CapturePlayground;
